export default __webpack_public_path__ + "static/media/4.1b8a8e47.jpg";